import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

export default (props) => (
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', ...(props.overlay ? { flexDirection: 'column', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.4)' } : {}), }}>
        <CircularProgress color={props.color ? props.color : "secondary"} style={{ zIndex: 1400 }}  />
        {props.children}
    </div>
);